"use client";

import React from "react";
import { useTranslations } from "next-intl";
import { contactInfo } from "@/lib/contacts";

const WhatsAppFloat: React.FC = () => {
	const t = useTranslations();
	const waNumber = (contactInfo.whatsapp || "").replace(/[^0-9]/g, "");

	if (!waNumber) return null;

	const waHref = `https://wa.me/${waNumber}`;

	return (
		<a
			href={waHref}
			target="_blank"
			rel="noopener noreferrer"
			aria-label={t("common.chatOnWhatsApp")}
			className="group relative flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_8px_24px_-4px_rgba(37,211,102,0.55)] transition-transform duration-200 hover:scale-105 max-md:h-12 max-md:w-12"
		>
			<span className="absolute inset-0 -z-10 animate-ping rounded-full bg-[#25D366] opacity-40" />
			<i className="ri-whatsapp-line text-[28px] max-md:text-[24px]" />
			<span className="pointer-events-none absolute right-full top-1/2 mr-3 -translate-y-1/2 whitespace-nowrap rounded-md bg-brand-ink/90 px-3 py-1.5 font-body text-[12px] font-medium tracking-[0.04em] text-white opacity-0 shadow-lg transition-opacity duration-200 group-hover:opacity-100 max-md:hidden">
				{t("common.chatOnWhatsApp")}
			</span>
		</a>
	);
};

export default WhatsAppFloat;
